<template>
    <div id="ImportacionMovimientos_div" class="w-100 px-0 py-0">
        <div id="TituloImportacion_div">
            <h5 style="margin-top: 0px;">IMPORTACIÓN DE REGISTROS</h5>
            <h6 style="margin-top: 0px;">Importa registros de movimientos de altas, bajas y movimientos de personal</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
                <div class="area">
                    <div class="row">
                        <div class="form-group col-12" >
                            <label>Seleccione el archivo Excel a importar</label>
                            <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".xls, .xlsx" style="width: 100%"/>
                        </div>
                    </div>
                    <div class="row" v-if="ValidaArchivo==true && archivo!=null">
                        <div class="form-group col-12" >
                            <label>Movimientos</label>
                            <select id="catalogodeMovimientos" class="form-control" @change="cambiarMovimiento($event)">
                                <option value= 0>Seleccione Movimiento</option>
                                <option v-for="option in TipoMovimiento" v-bind:value="option.id" :key="option.Id">{{ option.value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-dark"  @click='Subir()' v-if="SeleccionMovimiento==true && archivo!=null">Importar Registros</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
                <div class="area" v-if="MostrarAltas">
                    <div>
                        <h6>Listado de Personal para Alta</h6>
                    </div>
                    <div>
                        <div id="altas_table" class="table-responsive">
                            <table class="table table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Persona a Movimiento</th>
                                        <th>Puesto a Movimiento</th>
                                        <th>Persona quien cubre</th>
                                        <th>Fecha Movimiento</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-for="(Lista, index) in ListadoAltas">
                                        <td v-html="DatosPersona(Lista.PersonaNueva, true)"></td>
                                        <td v-html="desglosePuesto(Lista.Estructura, Lista.PersonaAnterior.EstructuraOrganica)"></td>
                                        <td v-html="DatosPersona(Lista.PersonaAnterior, false)"></td>
                                        <td v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td>
                                        <td width= "30">
                                            <a v-on:click="eliminarRowAltas(index)" title="Eliminar Movimiento">
                                                <i class="fas fa-minus-circle"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right" v-if="dehabilitarBoton==false">
                                <button class="btn btn-primary"  @click='confirmarAltas(ListadoAltas)' >Confimar Altas</button>
                            </div>
                            <div v-else>
                                <h6 class="text-warning">Para efectuar los movimientos de alta, verifique la información de origen y vuelva a cargar el archivo de Excel o elimine de tabla los registros con observaciones.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="area" v-if="MostrarBajas">
                    <div>
                        <h6>Listado de Personal para Baja</h6>
                    </div>
                    <div>
                        <div id="bajas_table" class="table-responsive">
                            <table class="table table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>No. Nómina</th>
                                        <th>Nombre</th>
                                        <th>Adscripción</th>
                                        <th>Departamento</th>
                                        <th>Puesto</th>
                                        <th>Fecha de Baja</th>
                                        <th>Motivo</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-for="(Lista, indice) in ListadoBajas" :key="Lista.PersonaId">
                                        <td>{{Lista.NumeroNomina}}</td>
                                        <td v-html="statusParaBaja(Lista)"></td>
                                        <td>{{Lista.PersonaId>0 ? Lista.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre : ''}}</td>
                                        <td>{{Lista.PersonaId>0 ? (Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!=null ? Lista.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre : '') : '' }}</td>
                                        <td>{{Lista.PersonaId>0 ? Lista.EstructuraOrganica.Puesto.Nombre :''}}</td>
                                        <td>{{Lista.PersonaId>0 ? Lista.HistorialLaboral[1].FechaInicial : ''}}</td>
                                        <td>{{Lista.PersonaId>0 ? Lista.HistorialLaboral[1].TipoMovimiento.NombreMovimiento : ''}}</td>
                                        <td width= "30">
                                            <a v-on:click="eliminarRow(indice)" title="Eliminar Movimiento">
                                                <i class="fas fa-minus-circle"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right" v-if="dehabilitarBoton==false">
                                <button class="btn btn-danger"  @click='confirmarBajas(ListadoBajas)' >Confimar Bajas</button>
                            </div>
                            <div v-else>
                                <h6 class="text-warning">Para efectuar los movimientos de baja, verifique la información de origen y vuelva a cargar el archivo de Excel o elimine de tabla los registros con observaciones.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="area" v-if="MostrarMovimientos">
                    <div>
                        <h6>Listado de Personal para Movimiento</h6>
                    </div>
                    <div>
                        <h6>Total de Movimientos a importar: {{this.ListadoMovimientos.length}}</h6>
                    </div>
                    <div>
                        <div id="movimientos_table" class="table-responsive">
                            <table class="table table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Persona a Movimiento</th>
                                        <th>Puesto a Movimiento</th>
                                        <th>Persona quien cubre</th>
                                        <th>Fecha Movimiento</th>
                                        <th>Tipo Movimiento</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-for="(Lista, index) in ListadoMovimientos">
                                        <td v-html="DatosPersona(Lista.PersonaNueva, true)"></td>
                                        <td v-html="desglosePuesto(Lista.Estructura, Lista.PersonaAnterior.EstructuraOrganica)"></td>
                                        <td v-html="DatosPersona(Lista.PersonaAnterior, false)"></td>
                                        <td v-html="obtenFechaConFormato(Lista.FechaMovimiento)"></td>
                                        <td>{{Lista.TipoMovimiento.NombreMovimiento}}</td>
                                        <td width= "30">
                                            <a v-on:click="eliminarRowMovimientos(index)" title="Eliminar Movimiento">
                                                <i class="fas fa-minus-circle"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right" v-if="dehabilitarBoton==false">
                                <button class="btn btn-primary"  @click='confirmarMovimientos(ListadoMovimientos)' >Confimar Movimientos</button>
                            </div>
                            <div v-else>
                                <h6 class="text-warning">Para efectuar los movimientos de personal, verifique la información de origen y vuelva a cargar el archivo de Excel o elimine de tabla los registros con observaciones.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import router from '@/router/index'
import axios from 'axios'

export default {
    data(){
        return {
            enumeraciones,
            archivo: null,
            urlDocumento: "",
            ValidaArchivo: false,
            SeleccionMovimiento: false,
            TipoMovimiento : [
                {id: 1, value: "Altas de Personal"},
                {id: 2, value: "Bajas de Personal"},
                {id: 3, value: "Movimientos de Personal"}
            ],
            parametros: {
                extensionDocumento: ['xls', 'xlsx'],
            },
            MovimientoSeleccionado : 0,
            ListadoBajas :[],
            ListadoAltas : [],
            ListadoMovimientos : [],
            MostrarAltas :false,
            MostrarBajas : false,
            MostrarMovimientos: false,
            HistorialLaboral :[],
            ContadorPersonaMovimiento: [],
            ContadorEstructuras: [],
            ContadorPersonaACubrir: [],
            dehabilitarBoton: false
        }
    },
    methods :{
        cargarArchivo:function(evento){
            this.ValidaArchivo= false;
            this.SeleccionMovimiento=false;
            if(this.verificaQueSeaElDocumentoCorrecto(evento)) {                                 
                this.archivo = evento.target.files[0];
                this.ValidaArchivo = true;
            }
            else{
                this.archivo = null;
                this.ValidaArchivo= false;
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(evento) {
            let siEsUnDocumentoValido = false;      
            //Se verifica que haya documento
            if(evento.target.files.length <= 0) {          
            $("#archivoaSubir").val('');
            this.archivo = null;     
            this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.' 
            return siEsUnDocumentoValido;    
            }

            const nombreCortado = evento.target.files[0].name.split(".");        
            if (this.parametros.extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
            siEsUnDocumentoValido = true;
            else{
            let extensiones = "";
            this.parametros.extensionDocumento.forEach((element, index) => {
                extensiones += " ." + element;
                if(index < this.parametros.extensionDocumento.length - 1)
                extensiones += ",";
            });
            comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo valido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
            $("#archivoaSubir").val('');
            this.archivo = null; 
            
            return siEsUnDocumentoValido;
            }
            
            return siEsUnDocumentoValido;
        },
        cambiarMovimiento: function(datos){
            this.MovimientoSeleccionado = parseInt(datos.target.value);
            if(this.MovimientoSeleccionado>0)
            {
                this.SeleccionMovimiento=true;
            }
            else
            {
                this.SeleccionMovimiento=false;
            }
        },
        Subir: function(){
            let _this = this;
            if(this.archivo!=null)
            {
                $('#navaltas_table').remove();
                $('#navbajas_table').remove();
                $('#navmovimientos_table').remove();
                this.MostrarBajas = false;
                this.MostrarAltas =false;
                this.MostrarMovimientos = false;
                this.MostrarDetalles = false;
                this.ListadoAltas = [];
                this.ListadoBajas = [];
                this.ListadoMovimientos = [];
                this.DetallesFechasMovimientos = [];
                this.ContadorEstructuras=[];
                this.ContadorPersonaACubrir=[];
                this.ContadorPersonaMovimiento=[];
                this.dehabilitarBoton = false;
                    comun.SeEstaCargandoInformacion(true); 
                    var datosDelFormulario = new FormData();
                    datosDelFormulario.append("Archivo", this.archivo);
                    datosDelFormulario.append("Movimiento", this.MovimientoSeleccionado);
                    axios.post(api.conexion + api.SIAP.funcion.ImportarDatos, datosDelFormulario,
                        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
                    ).then(respuesta => { 
                        if(respuesta.data.SiHayError){
                            this.archivo = null;
                            $("#catalogodeMovimientos option[value='0']").prop("selected",true);
                            $("#archivoaSubir").val('');
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                  
                        } 
                        else { 
                            this.ListadoBajas = respuesta.data.PersonasBaja!=null ? respuesta.data.PersonasBaja : [];
                            this.ListadoAltas = respuesta.data.PersonasAltas!=null ? respuesta.data.PersonasAltas : [];
                            this.ListadoMovimientos = respuesta.data.PersonasMovimientos!=null ? respuesta.data.PersonasMovimientos : [];

                            if(this.ListadoBajas.length>0)
                            {
                                this.MostrarBajas = true;
                                this.MostrarAltas =false;
                                this.MostrarMovimientos = false;
                                this.ContadorPersonaMovimiento= this.ListadoBajas.filter(a=>a.PersonaId==0);
                                if(this.ContadorPersonaMovimiento.length>0)
                                {
                                    this.dehabilitarBoton =true;
                                }
                                else
                                {
                                    this.dehabilitarBoton = false
                                }
                                if(this.ListadoBajas.length>10)
                                {
                                    this.$nextTick(()=> { PaginarTabla('bajas_table', 10)});
                                }
                            }
                            if(this.ListadoAltas.length>0)
                            {
                                this.MostrarBajas = false;
                                this.MostrarAltas =true;
                                this.MostrarMovimientos = false;
                                this.ContadorEstructuras = this.ListadoAltas.filter(a=>a.Estructura.EstructuraOrganicaId==0);
                                this.ContadorPersonaACubrir = this.ListadoAltas.filter(a=>a.PersonaAnterior.PersonaId==0);
                                
                                if(this.ContadorEstructuras.length>0 || this.ContadorPersonaACubrir.length>0)
                                {
                                    this.dehabilitarBoton =true;
                                }
                                else
                                {
                                    this.dehabilitarBoton = false
                                }
                                if(this.ListadoAltas.length>10)
                                {
                                    this.$nextTick(()=> { PaginarTabla('altas_table', 10)});
                                }
                            }
                            if(this.ListadoMovimientos.length>0)
                            {
                                this.MostrarBajas = false;
                                this.MostrarAltas =false;
                                this.MostrarMovimientos = true;
                                this.ContadorEstructuras = this.ListadoMovimientos.filter(a=>a.Estructura.EstructuraOrganicaId==0);
                                this.ContadorPersonaMovimiento= this.ListadoMovimientos.filter(a=>a.PersonaNueva.PersonaId==0);
                                this.ContadorPersonaACubrir = this.ListadoMovimientos.filter(a=>a.PersonaAnterior.PersonaId==0 && a.PersonaAnterior.NumeroNomina!=0);
                                if(this.ContadorEstructuras.length>0 || this.ContadorPersonaACubrir.length>0 || this.ContadorPersonaMovimiento.length>0)
                                {
                                    this.dehabilitarBoton =true;
                                }
                                else
                                {
                                    this.dehabilitarBoton = false
                                }
                                if(this.ListadoMovimientos.length>10)
                                {
                                    this.$nextTick(()=> { PaginarTabla('movimientos_table', 10)});
                                }
                            }
                            switch(this.MovimientoSeleccionado)
                            {
                                case 1:
                                    if(this.ListadoAltas.length==0)
                                    {
                                        comun.mensajeDeAlerta("No hay registros para alta, verifique el origen de la importación", null, null);  
                                    }
                                    break;
                                case 2:
                                    if(this.ListadoBajas.length==0)
                                    {
                                        comun.mensajeDeAlerta("No hay registros para baja, verifique el origen de la importación", null, null);  
                                    }
                                    break;
                                case 3:
                                    if(this.ListadoMovimientos.length==0)
                                    {
                                        comun.mensajeDeAlerta("No hay registros para movimiento, verifique el origen de la importación", null, null);  
                                    }
                                    break;
                            }
                            
                            this.archivo = null;
                            $("#catalogodeMovimientos option[value='0']").prop("selected",true);
                            $("#archivoaSubir").val('');
                        }
                        comun.SeEstaCargandoInformacion(false);
                        //console.log(this.ListadoMovimientos);
                    }
                    ).catch(excepcion => {
                        this.archivo = null;
                        $("#catalogodeMovimientos option[value='0']").prop("selected",true);
                        $("#archivoaSubir").val('');
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);                
                    });    
                //}
            }
        },
        confirmarBajas: function(datos)
        {
            let peticion = {"ListadoBajas": datos}
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.BajasDePersonal, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    comun.SeEstaCargandoInformacion(true);
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    this.ListadoBajas = [];
                    this.MostrarBajas = false;
                }
                comun.SeEstaCargandoInformacion(false);
                    
            })
            .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
            })
        },
        eliminarRow: function(datos){
            if(this.MostrarBajas==true)
            {
                this.ListadoBajas.splice(datos,1);
                if(this.ListadoBajas.length>10)
                {
                     $('#navbajas_table').remove();
                    this.$nextTick(()=> { PaginarTabla('bajas_table', 10)});
                }
                if(this.ListadoBajas.length<=0)
                {
                    this.MostrarBajas = false;
                }
                this.ContadorPersonaMovimiento= this.ListadoBajas.filter(a=>a.PersonaId==0);
                if(this.ContadorPersonaMovimiento.length>0)
                {
                    this.dehabilitarBoton =true;
                }
                else
                {
                    this.dehabilitarBoton = false
                }
            }
        },
        DatosPersona: function(datos, bandera){
            let Contenido =''
            if(datos!=null && datos.PersonaId>0)
            {
                if(bandera==true)
                {
                    Contenido=Contenido + 'Nombre: ' + datos.NombreCompleto + '<br>';
                    Contenido = Contenido + 'No. Nómina: ' + datos.NumeroNomina + '<br>';
                    if(datos.EstructuraOrganica!=null)
                    {
                        Contenido=Contenido + 'Puesto : ' + (datos.EstructuraOrganica!=null ? (datos.EstructuraOrganica.Puesto.Nombre + '<br>') : ('' + '<br>')) ;
                        Contenido=Contenido + 'Departamento: ' + ((datos.EstructuraOrganica!=null && datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!= null) ? (datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre + '<br>') : ('' + '<br>'));
                        Contenido=Contenido + 'Área: ' + (datos.EstructuraOrganica!=null ? (datos.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre + '<br>') : ('' + '<br>')) ;
                        Contenido = Contenido + (datos.HistorialLaboral!=null ? ('Periódo Actual: ' + this.obtenFechaConFormato(datos.HistorialLaboral[0].FechaInicial) + ' - ' + (datos.HistorialLaboral[0].FechaFinal!=null ? this.obtenFechaConFormato(datos.HistorialLaboral[0].FechaFinal) : '')) : '');
                    }
                }
                else
                {
                    let ultimoPeriodo= datos.HistorialLaboral.length -1;
                    Contenido=Contenido + 'Nombre: ' + datos.NombreCompleto + '<br>';
                    Contenido = Contenido + 'No. Nómina: ' + datos.NumeroNomina + '<br>';
                    Contenido=Contenido + 'Puesto : ' + datos.EstructuraOrganica.Puesto.Nombre + '<br>';
                    Contenido=Contenido + 'Departamento: ' + (datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!= null ? (datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre + '<br>') : ('' + '<br>'));
                    Contenido=Contenido + 'Área: ' + datos.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre + '<br>';
                    Contenido = Contenido + 'Periódo Actual: ' + this.obtenFechaConFormato(datos.HistorialLaboral[ultimoPeriodo].FechaInicial) + ' - ' + (datos.HistorialLaboral[ultimoPeriodo].FechaFinal!=null ? this.obtenFechaConFormato(datos.HistorialLaboral[ultimoPeriodo].FechaFinal) : '');
                }
                
            }
            else
            {
                if (bandera==true)
                {
                    Contenido=Contenido + (datos.Nombre!=null ? ('Nombre: ' + datos.NombreCompleto + '<br>') : ('<h6><span class="badge badge-pill badge-danger text-center">No hay Registro de personal con numero de nómina : ' + datos.NumeroNomina + '</span></h6>'));
                    Contenido = Contenido + 'No. Nómina: ' + datos.NumeroNomina + '<br>';
                    if(datos.EstructuraOrganica!=null)
                    {
                        Contenido=Contenido + 'Puesto : ' + (datos.EstructuraOrganica!=null ? (datos.EstructuraOrganica.Puesto.Nombre + '<br>') : ('' + '<br>')) ;
                        Contenido=Contenido + 'Departamento: ' + ((datos.EstructuraOrganica!=null && datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento!= null) ? (datos.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre + '<br>') : ('' + '<br>'));
                        Contenido=Contenido + 'Área: ' + (datos.EstructuraOrganica!=null ? (datos.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre + '<br>') : ('' + '<br>')) ;
                        Contenido = Contenido + (datos.HistorialLaboral!=null ? ('Periódo Actual: ' + this.obtenFechaConFormato(datos.HistorialLaboral[0].FechaInicial) + ' - ' + (datos.HistorialLaboral[0].FechaFinal!=null ? this.obtenFechaConFormato(datos.HistorialLaboral[0].FechaFinal) : '')) : '');
                    }
                }
                else
                {
                    if(datos.PersonaId==0 && datos.NumeroNomina!=0)
                    {
                        if(datos.NumeroNomina!=0)
                        {
                            if(this.ListadoAltas.length>0)
                            {
                                let buscaPersonaNueva = this.ListadoAltas.find(a=>a.PersonaNueva.NumeroNomina==datos.NumeroNomina);
                                if(buscaPersonaNueva!=undefined)
                                {
                                    let obtenemosElementosEnRow = this.ListadoAltas.find(b=>b.PersonaAnterior.NumeroNomina ==datos.NumeroNomina);
                                    if(obtenemosElementosEnRow!=undefined)
                                    {
                                        
                                        let index = this.ListadoAltas.indexOf(obtenemosElementosEnRow);
                                        this.ListadoAltas[index].PersonaAnterior.NombreCompleto = buscaPersonaNueva.PersonaNueva.NombreCompleto; 
                                        this.ListadoAltas[index].PersonaAnterior.EstructuraOrganica = buscaPersonaNueva.PersonaNueva.EstructuraOrganica; 
                                    }
                                    Contenido = Contenido + '<h6><span class="badge badge-pill badge-warning text-center">En Proceso de alta con numero de nómina : ' + buscaPersonaNueva.PersonaNueva.NumeroNomina + '</span></h6><br>';
                                    Contenido = Contenido + '<h6><span class="badge badge-pill badge-warning text-center">Nombre : ' + buscaPersonaNueva.PersonaNueva.NombreCompleto +'</span></h6>';

                                }
                                else
                                {
                                    Contenido ='<h6><span class="badge badge-pill badge-danger text-center">No Existe Registro de personal con numero de nómina : ' + datos.NumeroNomina + '</span></h6>';
                                }
                            }
                            if(this.ListadoMovimientos.length>0)
                            {
                                Contenido ='<h6><span class="badge badge-pill badge-danger text-center">No Existe Registro de personal con numero de nómina : ' + datos.NumeroNomina + '</span></h6>';
                            }
                        }
                        else
                        {
                            
                            Contenido ='<h6><span class="badge badge-pill badge-danger text-center">No Existe Registro de personal con numero de nómina : ' + datos.NumeroNomina + '</span></h6>';
                        }
                    }
                    else
                    {
                        Contenido= '';
                    }
                    
                }
            }
            return Contenido;
        },
        desglosePuesto: function(datos, estructuraAnterior){
            let puesto = '';
            if(datos.EstructuraOrganicaId!=null && datos.EstructuraOrganicaId>0)
            {
                puesto = puesto + datos.TipoDepartamentoArea.Area.Nombre + '<br>';
                puesto = puesto + (datos.TipoDepartamentoArea.TipoDepartamento!=null ? datos.TipoDepartamentoArea.TipoDepartamento.Nombre : '') + '<br>';
                puesto = puesto + datos.Puesto.Nombre;
                if(estructuraAnterior!=null && datos.EstructuraOrganicaId==estructuraAnterior.EstructuraOrganicaId)
                {
                    puesto = '<b class="text-success">' + puesto + '</b>'
                }
                else
                {
                    if(estructuraAnterior!=null)
                    {
                         puesto = '<b class="text-warning">' + puesto + '</b>'
                    }
                    else
                    {
                         puesto = '<b class="text-dark">' + puesto + '</b>'
                    }
                   
                }
            }
            else
            {
                puesto = '<h6><span class="badge badge-pill badge-danger text-center">' +'Error en información del Puesto, verifique.' + '</span></h6>';
            }
            return puesto
        },
        obtenFechaConFormato: function(fechaRegistro) {
            return moment(fechaRegistro).format("DD/MM/YYYY");
        },
        confirmarMovimientos: function (datos){
            let movimientoHistorial = [];
            let Persona = [];
            $.each(datos, function(id, movimiento)
            {
                let VerificarMovimiento = datos.find(a=>a.PersonaNueva.PersonaId==movimiento.PersonaAnterior.PersonaId && a.FechaMovimiento<movimiento.FechaMovimiento);
                if(VerificarMovimiento!=undefined)
                {
                    movimiento.PersonaAnterior.EstructuraOrganicaId = VerificarMovimiento.Estructura.EstructuraOrganicaId;
                    movimiento.PersonaAnterior.EstructuraOrganica= VerificarMovimiento.Estructura
                }
                Persona.push ({
                    "PersonaId" : movimiento.PersonaNueva.PersonaId,
                    "FechaMovimiento" : movimiento.FechaMovimiento,
                    "EstructuraNueva" : movimiento.Estructura.EstructuraOrganicaId,
                    "EstructuraAnterior" : movimiento.PersonaNueva.EstructuraOrganica.EstructuraOrganicaId,
                    "EstructuraSuplir" :  movimiento.PersonaAnterior.EstructuraOrganica!=null ? movimiento.PersonaAnterior.EstructuraOrganica.EstructuraOrganicaId : 0,
                    "PersonaACubrir" : movimiento.PersonaAnterior.PersonaId
                });
                let FechaCerrarCiclo = moment(movimiento.FechaMovimiento).add({'days': -1}).format('YYYY-MM-DD');
                //Cerramos ciclo de persona nueva en caso de que no este cerrado el ultimo ciclo
                if(movimientoHistorial.filter(a=>a.PersonaId == movimiento.PersonaNueva.PersonaId)==0)
                {
                    if(movimiento.PersonaNueva.HistorialLaboral[0].FechaFinal==null)
                    {
                        movimiento.PersonaNueva.HistorialLaboral[0].FechaFinal=FechaCerrarCiclo;
                        movimientoHistorial.push(movimiento.PersonaNueva.HistorialLaboral[0]);
                    }
                }
                
                if(movimiento.PersonaAnterior.EstructuraOrganica!=null)
                {
                    if(movimiento.Estructura.EstructuraOrganicaId==movimiento.PersonaAnterior.EstructuraOrganica.EstructuraOrganicaId)
                    {
                        var movimientosPorPersona = movimientoHistorial.filter(a=>a.PersonaId == movimiento.PersonaNueva.PersonaId);
                        if(movimientosPorPersona.length>0)
                        {
                            let indiceParaUbicar = movimientosPorPersona[movimientosPorPersona.length -1];
                            let indiceEnListado = movimientoHistorial.indexOf(indiceParaUbicar);
                            if(movimientoHistorial[indiceEnListado].FechaFinal== null)
                            {
                                movimientoHistorial[indiceEnListado].FechaFinal=FechaCerrarCiclo
                            }
                        }
                        movimientoHistorial.push(
                        {
                            "Activo" : true,
                            "CausoBaja": null,
                            "EstructuraOrganica" : movimiento.Estructura,
                            "FechaInicial": movimiento.FechaMovimiento,
                            "FechaFinal": null,
                            "PersonaId": movimiento.PersonaNueva.PersonaId,
                            "TipoContrato" : movimiento.PersonaNueva.HistorialLaboral[0].TipoContrato,
                            "TipoMovimiento": movimiento.TipoMovimiento,
                            "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                        });
                    }
                    else
                    {
                        var movimientosPorPersona = movimientoHistorial.filter(a=>a.PersonaId == movimiento.PersonaNueva.PersonaId);
                        if(movimientosPorPersona.length>0)
                        {
                            
                            let indiceParaUbicar = movimientosPorPersona[movimientosPorPersona.length -1];
                            let indiceEnListado = movimientoHistorial.indexOf(indiceParaUbicar);
                            if(movimientoHistorial[indiceEnListado].FechaFinal== null)
                            {
                                movimientoHistorial[indiceEnListado].FechaFinal=FechaCerrarCiclo
                            }
                        }
                        
                        movimientoHistorial.push(
                        {
                            "Activo" : true,
                            "CausoBaja": null,
                            "EstructuraOrganica" : movimiento.PersonaAnterior.EstructuraOrganica,
                            "FechaInicial": movimiento.FechaMovimiento,
                            "FechaFinal": movimiento.FechaMovimiento,
                            "PersonaId": movimiento.PersonaNueva.PersonaId,
                            "TipoContrato" : movimiento.PersonaNueva.HistorialLaboral[0].TipoContrato,
                            "TipoMovimiento": movimiento.TipoMovimiento,
                            "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                        });
                        
                        movimientoHistorial.push(
                        {
                            "Activo" : true,
                            "CausoBaja": null,
                            "EstructuraOrganica" : movimiento.Estructura,
                            "FechaInicial": movimiento.FechaMovimiento,
                            "FechaFinal": null,
                            "PersonaId": movimiento.PersonaNueva.PersonaId,
                            "TipoContrato" : movimiento.PersonaNueva.HistorialLaboral[0].TipoContrato,
                            "TipoMovimiento": movimiento.TipoMovimiento,
                            "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                        });
                    }
                }
                else
                {
                    var movimientosPorPersona = movimientoHistorial.filter(a=>a.PersonaId == movimiento.PersonaNueva.PersonaId);
                        if(movimientosPorPersona.length>0)
                        {
                            let indiceParaUbicar = movimientosPorPersona[movimientosPorPersona.length -1];
                            let indiceEnListado = movimientoHistorial.indexOf(indiceParaUbicar);
                            if(movimientoHistorial[indiceEnListado].FechaFinal== null)
                            {
                                movimientoHistorial[indiceEnListado].FechaFinal=FechaCerrarCiclo
                            }
                        }
                        movimientoHistorial.push(
                        {
                            "Activo" : true,
                            "CausoBaja": null,
                            "EstructuraOrganica" : movimiento.Estructura,
                            "FechaInicial": movimiento.FechaMovimiento,
                            "FechaFinal": null,
                            "PersonaId": movimiento.PersonaNueva.PersonaId,
                            "TipoContrato" : movimiento.PersonaNueva.HistorialLaboral[0].TipoContrato,
                            "TipoMovimiento": movimiento.TipoMovimiento,
                            "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                        });
                }
            })
            let dbSIAPPersona = [];
            $.each(Persona, function (id, elemento)
            {
                dbSIAPPersona.push({
                    "PersonaId": elemento.PersonaId,
                    "EstructuraOrganicaId":elemento.EstructuraNueva
                })
            })
            let peticion = {
                "HistorialLaboral" : movimientoHistorial,
                "Personas" : dbSIAPPersona
            }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.MovimientosDePersonal, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    comun.SeEstaCargandoInformacion(true);
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    this.ListadoMovimientos = [];
                    this.MostrarMovimientos = false;
                }
                comun.SeEstaCargandoInformacion(false);    
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
            })
        },
        eliminarRowMovimientos: function(datos){
            this.ListadoMovimientos.splice(datos,1);
            if(this.ListadoMovimientos.length>10)
            {
                $('#navmovimientos_table').remove();
                this.$nextTick(()=> { PaginarTabla('movimientos_table', 10)});
            }
            if(this.ListadoMovimientos.length<=0)
            {
                this.MostrarMovimientos = false
            }
            this.ContadorEstructuras = this.ListadoMovimientos.filter(a=>a.Estructura.EstructuraOrganicaId==0);
            this.ContadorPersonaMovimiento= this.ListadoMovimientos.filter(a=>a.PersonaNueva.PersonaId==0);
            this.ContadorPersonaACubrir = this.ListadoMovimientos.filter(a=>a.PersonaAnterior.PersonaId==0 && a.PersonaAnterior.NumeroNomina!=0);
            
            if(this.ContadorEstructuras.length>0 || this.ContadorPersonaACubrir.length>0 || this.ContadorPersonaMovimiento.length>0)
            {
                this.dehabilitarBoton =true;
            }
            else
            {
                this.dehabilitarBoton = false
            }
        },
        confirmarAltas: function(datos){
            let movimientoHistorial = [];
            let Persona = [];
            $.each(datos, function(id, movimiento)
            {
                movimiento.PersonaNueva.HistorialLaboral= [];
                if(movimiento.PersonaAnterior.EstructuraOrganicaId == movimiento.Estructura.EstructuraOrganicaId)
                {
                    let datoHistorial = 
                    {
                        "Activo" : true,
                        "CausoBaja": null,
                        "EstructuraOrganica" : movimiento.Estructura,
                        "FechaInicial": movimiento.FechaMovimiento,
                        "FechaFinal": null,
                        "PersonaId": movimiento.PersonaNueva.PersonaId,
                        "TipoContrato" : {"TipoContratoId" : 1},
                        "TipoMovimiento": {"TipoMovimientoId" : movimiento.PersonaNueva.PersonaId!=0 ? 6 : 4},
                        "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                    };
                    movimiento.PersonaNueva.EstructuraOrganicaId = movimiento.Estructura.EstructuraOrganicaId;
                    movimiento.PersonaNueva.HistorialLaboral.push(datoHistorial);
                    Persona.push(movimiento.PersonaNueva);
                }
                else
                {
                    if(movimiento.PersonaAnterior.HistorialLaboral!=null)
                    {
                        let datoNuevoHistorial =
                        {
                            "Activo" : true,
                            "CausoBaja": null,
                            "EstructuraOrganica" : movimiento.PersonaAnterior.HistorialLaboral!=null ? movimiento.PersonaAnterior.HistorialLaboral[0].EstructuraOrganica :movimiento.Estructura.EstructuraOrganicaId ,
                            "FechaInicial": movimiento.FechaMovimiento,
                            "FechaFinal": movimiento.FechaMovimiento,
                            "PersonaId": movimiento.PersonaNueva.PersonaId,
                            "TipoContrato" : {"TipoContratoId" : 1},
                            "TipoMovimiento": {"TipoMovimientoId" : movimiento.PersonaNueva.PersonaId!=0 ? 6 : 4},
                            "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                        };
                        movimiento.PersonaNueva.HistorialLaboral.push(datoNuevoHistorial);
                    }
                    let datoHistorialFinal = 
                    {
                        "Activo" : true,
                        "CausoBaja": null,
                        "EstructuraOrganica" : movimiento.Estructura,
                        "FechaInicial": movimiento.FechaMovimiento,
                        "FechaFinal": null,
                        "PersonaId": movimiento.PersonaNueva.PersonaId,
                        "TipoContrato" : {"TipoContratoId" : 1},
                        "TipoMovimiento": {"TipoMovimientoId" : 1 },
                        "UsuarioIdQuienRegistra_001DBCUENTAS": 6
                    };
                    movimiento.PersonaNueva.EstructuraOrganicaId = movimiento.Estructura.EstructuraOrganicaId;
                    movimiento.PersonaNueva.HistorialLaboral.push(datoHistorialFinal);
                    Persona.push(movimiento.PersonaNueva);
                }

            });
            let peticion = {
                "HistorialLaboral" : movimientoHistorial,
                "Personas" : Persona
            }
           
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.AltasDePersonal, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    comun.SeEstaCargandoInformacion(true);
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    this.ListadoAltas = [];
                    this.MostrarAltas = false;
                }
                comun.SeEstaCargandoInformacion(false);    
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
            })
        },
        eliminarRowAltas: function (datos)
        {
            console.log(this.ListadoAltas);
            this.ListadoAltas.splice(datos,1);
            if(this.ListadoAltas.length>10)
            {
                $('#navaltas_table').remove();
                this.$nextTick(()=> { PaginarTabla('altas_table', 10)});
            }
            if(this.ListadoAltas.length<=0)
            {
                this.MostrarAltas = false
            }
            this.ContadorEstructuras = this.ListadoAltas.filter(a=>a.Estructura.EstructuraOrganicaId==0);
            this.ContadorPersonaACubrir = this.ListadoAltas.filter(a=>a.PersonaAnterior.PersonaId==0 && a.PersonaAnterior.NombreCompleto=="  ");      
            console.log(this.ContadorPersonaACubrir)         
            if(this.ContadorEstructuras.length>0 || this.ContadorPersonaACubrir.length>0)
            {
                this.dehabilitarBoton =true;
            }
            else
            {
                this.dehabilitarBoton = false
            }
        },
        statusParaBaja: function(datos)
        {
            let nombre = ''
            if(datos.PersonaId>0 && datos.Activo)
            {
                nombre = nombre + datos.NombreCompleto
            }
            if(datos.PersonaId>0 && datos.Activo==false)
            {
                nombre = nombre + datos.NombreCompleto + '</br>';
                nombre = nombre + '<h6><span class="badge badge-pill badge-danger text-center">Registro con baja vigente.</span></h6>'
            }
            if(datos.PersonaId<=0)
            {
                nombre = nombre + '<h6><span class="badge badge-pill badge-danger text-center">Sin registro en base de datos</span></h6>'
            }
            return nombre;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/ImportarRegistros.vue